import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import React from 'react';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import styles from './archiveCaseModal.module.css';
import { Modal, Button } from '@mui/material';
import { deleteItems, deleteOverviewModalClose} from 'src/store/details/overview/actions';

interface Props {
    readonly caseCode: string;
    readonly showDeleteModal: boolean;
    readonly deleteModalClose: () => typeof deleteOverviewModalClose;
    readonly deleteItems: typeof deleteItems;
}

class DeleteOverviewModal extends React.Component<Props> {
  private localization: Ii18n;

  constructor(props: Props) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
        <Modal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={this.props.showDeleteModal}
        onClose={() => this.props.deleteModalClose()}
        >
        <div className={styles.modal}>
          <div className={styles.rowCenter}>
             {this.localization.get('shared.deleteSelected')}
          </div>
          <br />
          <div className={styles.rowCenter}>
            <Button
              variant='contained'
              className={styles.button}
              onClick={() => this.props.deleteModalClose()} >
              {this.localization.get('shared.no')}
              </Button>
            <Button
              variant='contained'
              color='secondary'
              className={styles.button}
              onClick={() => {this.props.deleteItems(this.props.caseCode); }}>
              {this.localization.get('shared.yes')}
            </Button>
          </div>
        </div>
        </Modal>
    );
  }
}

export { DeleteOverviewModal };
